import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import Trans from 'components/Common/Translation/Trans';
import { getUri } from 'services/generic';

import styles from './ProductBrand.module.scss';

type Props = {
  brandName: string;
  brandStore?: string;
  classes?: { container?: string };
};

export default function ProductBrand({
  brandName,
  brandStore,
  classes,
}: Props): JSX.Element {
  return (
    <div className={classNames(styles.productBrand, classes?.container)}>
      <span>{brandName}</span>
      {brandStore && (
        <span className={styles.seeStoreWrapper}>
          {' '}
          <Trans
            i18nKey={'BRAND_SEE_SHOP'}
            namespace={'productPage'}
            additionalComponents={{
              brandLink: (
                <Link to={getUri(brandStore)} className={styles.brandLink} />
              ),
            }}
          />
        </span>
      )}
    </div>
  );
}
